module.exports = __webpack_public_path__ + "static/media/breaking-chain.38448895.svg";